import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'ax-toast-wrapper',
  template: '',
  encapsulation: ViewEncapsulation.None,
})
export class AXToastWrapperComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
